// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yv1h","rootNoMargin":"styles_rootNoMargin__2fDqe"};